import { Pipe, PipeTransform } from '@angular/core';

import { visibilidades } from './atividade-filter-visibilidade';

@Pipe({
    name: 'atividadeFilterVisibilidadeIcon'
})
export class AtividadeFilterVisibilidadeIconPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = visibilidades.findIndex(visibilidade => visibilidade.id === value);
        if (index > -1) {
            return visibilidades[index].iconClass;
        }
        return '';
    }
}
